import MarkdownIt from 'markdown-it'

export default function (content, options = {}) {
    const md = new MarkdownIt(Object.assign({
        html: false,
        linkify: false,
        typographer: false,
        breaks: true,
    }, options));

    md.disable([
        'blockquote',
        'code',
        'fence',
        'heading',
        'link',
        'image',
        'list',
        'table',
        'hr',
        'strikethrough',
    ]);

    return md.render(content);
}
